import React, { useEffect, useState } from "react";
import PublicHeader from "../components/header";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { showToast } from "../components/toastServices";
import APIService from "../components/postServices";
import {
  isValidMobileNumber,
  isValidMobileNumberWithcode,
} from "../components/ValidationServices";
import { useNavigate, useLocation } from "react-router-dom";
import { formatDate } from "../components/DateFormatServices";
import "primeicons/primeicons.css";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";

function SubmitForm() {
  const location = useLocation();
  const navigate = useNavigate();

  const [ApplicationData, setApplicationData] = useState(null);
  // Use a single useEffect to handle setting ApplicationData and redirection
  useEffect(() => {
    const data = location.state?.data;

    if (data) {
      setApplicationData(data);
    } else {
      navigate("/");
    }
  }, [location.state, navigate, ApplicationData]);

  const [loading, setLoading] = useState(false);

  const [StudentformData, setStudentFormData] = useState({});
  const [PaymentFormData, setPaymentFormData] = useState({});
  const [ApplicationCost, setApplicationCost] = useState(null);

  useEffect(() => {
    if (ApplicationData) {
      if (ApplicationData.applicationResponse) {
        setStudentFormData({
          no: ApplicationData && ApplicationData.applicationResponse.no,
          nameOfPupil:
            ApplicationData && ApplicationData.applicationResponse.nameOfPupil,
          // middleNameOfStudent: ApplicationData.middleNameOfStudent,
          applicantGender: ApplicationData.applicationResponse.applicantGender,
          emailAddress: ApplicationData.applicationResponse.emailAddress,
          mobileNumber: ApplicationData.applicationResponse.mobileNumber,
          fatherName: ApplicationData.applicationResponse.addressee
            ? ApplicationData.applicationResponse.addressee
            : ApplicationData.applicationResponse.fatherName
            ? ApplicationData.applicationResponse.fatherName
            : ApplicationData.applicationResponse.motherName,
          academicYear: ApplicationData.applicationResponse.academicYear,
          class: ApplicationData.applicationResponse.class,
          chequeDdDate: "2023-08-18T05:49:21.422Z",
          bankName: "string",
          modeOfSale: "WEBSITE",
          modeOfPayment: "ONLINE",
          applicationCost: 0,
          registrationCost: 0,
          chequeDdNo: "string",
          bankFees: 0,
          regDdChequeNo: "string",
          regDdChequeDate: "2023-08-18T05:49:21.423Z",
        });

        setApplicationCost(
          ApplicationData.applicationResponse.registrationCost +
            ApplicationData.applicationResponse.applicationCost
        );

        setPaymentFormData({
          order_id: ApplicationData.order_id,
          Amount:
            ApplicationData.applicationResponse.registrationCost +
            ApplicationData.applicationResponse.applicationCost,
          BillingName: ApplicationData.applicationResponse.addressee
            ? ApplicationData.applicationResponse.addressee
            : ApplicationData.applicationResponse.fatherName
            ? ApplicationData.applicationResponse.fatherName
            : ApplicationData.applicationResponse.motherName, // Parent name
          BillingAddress: ApplicationData.applicationResponse.address1,
          BillingCity: ApplicationData.applicationResponse.city,
          BillingState: ApplicationData.applicationResponse.state,
          BillingZip: ApplicationData.applicationResponse.postCode,
          BillingCountry: ApplicationData.applicationResponse.country,
          BillingTel: "",
          BillingEmail: ApplicationData.applicationResponse.emailAddress,
          MerchantParam1: "Registration Fee", // Company ID
          MerchantParam2: "", // School ID
          MerchantParam3: `${ApplicationData.applicationResponse.registrationCost}`, // Fee 1  {FeeRowId:1001,Fee:100}  GL
          MerchantParam4: `${ApplicationData.applicationResponse.applicationCost}`, //  Fee2 2    {FeeRowId:1002,Fee:750} GL
          MerchantParam5: ApplicationData.applicationResponse.no, //Student name
          CustomerIdentifier: ApplicationData.applicationResponse.no, // App no
          paymentOption: "",
          AcademicYear: ApplicationData.applicationResponse.academicYear,
          Class: ApplicationData.applicationResponse.class,
        });
      }
    }
  }, [ApplicationData]);

  const [CCAvenuePaymentSetup, setCCAvenuePaymentSetup] = useState();

  useEffect(() => {
    APIService.get(`/CCAvenuePayment/CCAvenuePaymentSetup`)
      .then((response) => {
        setCCAvenuePaymentSetup(response.data.dataSet);
      })
      .catch((error) => {
        // Handle API call errors here
        console.error("Error:", error);
      });
  }, []);
  console.log(PaymentFormData);

  const [UserformError, setFormError] = React.useState({});

  const [error, setError] = React.useState(false);
  const [errors, setErrors] = useState({});

  const PaymentformDataChange = (event) => {
    const { name, value } = event.target;
    // Update the form state with the new value
    setPaymentFormData({
      ...PaymentFormData,
      [name]: value,
    });

    // Perform validation on the fly and update the errors state
    const newErrors = {
      ...errors,
      [name]:
        name === "BillingTel"
          ? value !== "" && !isValidMobileNumber(value)
          : "",
    };
    setErrors(newErrors);
  };

  const handleError = (error, input) => {
    setFormError((prevState) => ({ ...prevState, [input]: error }));
    setError(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let isValid = true;

    let paymentOption = PaymentFormData.paymentOption;
    let BillingTel = PaymentFormData.BillingTel;

    if (!BillingTel) {
      handleError("Please input mobile number", "BillingTel");
      isValid = false;
    }
    if (!paymentOption) {
      handleError("Please select payment option", "paymentOption");
      isValid = false;
    }

    if (isValid) {
      try {
        // const response = await APIService.Put(
        //   `/EnquiryApplications/UpdateEnquiryApplication/${applicationNo}`,
        //   StudentformData
        // );

        const response = await APIService.Post(
          `/CCAvenuePayment/initiate`,
          PaymentFormData
        );
        console.log("response", response);
        if (response.responseCode === 1) {
          // navigate("/registration", {
          //   // state: { data: response.responseMessage },
          // });
          // setSuccess(true);
          setLoading(false);

          navigate("/Payment", {
            state: {
              data: response.dataSet,
              link: "/registration/form",
              status: "payment",
            },
            replace: true,
          });
        }
      } catch (error) {
        showToast("error", error.response.data.responseMessage);
      }
    }
    setLoading(false);
  };

  const goToPreviousPage = () => {
    navigate("/registration/form?status=update", {
      state: { data: ApplicationData },
      replace: true,
    });
  };

  const breadcrumb = [{ label: "Register", url: "/registration/form" }];

  return (
    <div className="main-page">
      {" "}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <PublicHeader breadcrumb={breadcrumb} title={"Register"} />
      <div className="content-wrapper  mt-10">
        <div className="col-md-12">
          <h3>
            Submit Registration Form
            <small>Make payment and submit the application form</small>
          </h3>

          <div className=" reg">
            <div className="box-header">
              <h3 className="box-title">Information</h3>
            </div>
            <div className="box-body">
              <div className="row">
                <div className="col-12 md:col-12 xl:col-6">
                  <div className="form-group row">
                    <label
                      className="col-12 md:col-12 xl:col-4 col-form-label"
                      // style={{ textAlign: "right" }}
                    >
                      Student Name :
                    </label>
                    <label className="col-12 md:col-12 xl:col-8 col-form-label">
                      {StudentformData.nameOfPupil}
                      {/* {StudentformData.middleNameOfStudent
                        ? ` ${StudentformData.middleNameOfStudent}`
                        : ""}
                      {StudentformData.lastNameOfStudent
                        ? ` ${StudentformData.lastNameOfStudent}`
                        : ""} */}
                    </label>
                  </div>
                  <div className="form-group row">
                    <label
                      className="col-12 md:col-12 xl:col-4 col-form-label"
                      // style={{ textAlign: "right" }}
                    >
                      Gender :
                    </label>
                    <label className="col-12 md:col-12 xl:col-8 col-form-label">
                      {StudentformData.applicantGender === 1
                        ? "Male"
                        : StudentformData.applicantGender === 2
                        ? "Female"
                        : ""}
                    </label>
                  </div>
                  <div className="form-group row">
                    <label
                      className="col-12 md:col-12 xl:col-4 col-form-label"
                      // style={{ textAlign: "right" }}
                    >
                      Date of Birth :
                    </label>
                    <label className="col-12 md:col-12 xl:col-8 col-form-label">
                      {formatDate(
                        ApplicationData &&
                          ApplicationData.applicationResponse &&
                          ApplicationData.applicationResponse.dateOfBirth
                      )}
                    </label>
                  </div>
                  <div className="form-group row">
                    <label
                      className="col-12 md:col-12 xl:col-4 col-form-label"
                      // style={{ textAlign: "right" }}
                    >
                      Diet :
                    </label>
                    <label className="col-12 md:col-12 xl:col-8 col-form-label">
                      {ApplicationData &&
                      ApplicationData.applicationResponse &&
                      ApplicationData.applicationResponse.foodHabits === 1
                        ? "Vegetarian"
                        : "Non-Vegetarian"}
                    </label>
                  </div>
                  <div className="form-group row">
                    <label
                      className="col-12 md:col-12 xl:col-4 col-form-label"
                      // style={{ textAlign: "right" }}
                    >
                      Academic year :
                    </label>
                    <label className="col-12 md:col-12 xl:col-8 col-form-label">
                      {StudentformData.academicYear}
                    </label>
                  </div>
                  <div className="form-group row">
                    <label
                      className="col-12 md:col-12 xl:col-4 col-form-label"
                      // style={{ textAlign: "right" }}
                    >
                      Class :
                    </label>
                    <label className="col-12 md:col-12 xl:col-8 col-form-label">
                      {StudentformData.class}
                    </label>
                  </div>
                  <div className="row col-12">
                    <Button label="Back" onClick={goToPreviousPage} />
                  </div>
                </div>
                <div className="col-12 md:col-12 xl:col-6">
                  <div className="form-group row">
                    <label
                      className="col-12 md:col-12 xl:col-4 col-form-label"
                      // style={{ textAlign: "right" }}
                    >
                      Reference No :
                    </label>
                    <label className="col-12 md:col-12 xl:col-8 col-form-label">
                      {ApplicationData && ApplicationData.order_id}
                    </label>
                  </div>
                  <div className="form-group row">
                    <label
                      className="col-12 md:col-12 xl:col-4 col-form-label"
                      // style={{ textAlign: "right" }}
                    >
                      Registration Amount :
                    </label>
                    <label className="col-12 md:col-12 xl:col-8 col-form-label">
                      INR {ApplicationCost ? ApplicationCost : 0}
                    </label>
                  </div>
                  <div className="form-group row">
                    <small>
                      Click on "Make payment" button to pay online. You will
                      receive an Application Number upon successfull payment.
                      Please enter below a valid mobile number
                    </small>
                  </div>
                  <div className="form-group row">
                    <label
                      className="col-12 md:col-12 xl:col-4 col-form-label"
                      // style={{ textAlign: "right" }}
                    >
                      Mobile Number :
                    </label>
                    <div className="col-12 md:col-12 xl:col-8">
                      <input
                        type="tel"
                        className={`form-control form-control-sm ${
                          errors.BillingTel ? "is-invalid" : ""
                        }`}
                        placeholder="1234567890"
                        id="BillingTel"
                        name="BillingTel"
                        value={PaymentFormData.BillingTel}
                        onChange={PaymentformDataChange}
                        onFocus={() => handleError(null, "BillingTel")}
                      />
                      {errors.BillingTel && (
                        <div className="invalid-feedback">
                          Invalid mobile number
                        </div>
                      )}
                      {error && UserformError.BillingTel && (
                        <div className="text-red">
                          {UserformError.BillingTel}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-12 md:col-12 xl:col-4 col-form-label">
                      Payment option{" "}
                      <i aria-hidden="true" className="ml-2 redColor">
                        {" "}
                        *{" "}
                      </i>
                      :
                    </label>
                    <div className="col-12 md:col-12 xl:col-8">
                      <RadioButton
                        inputId="ingredient1"
                        name="paymentOption"
                        value="OPTCRDC"
                        onChange={PaymentformDataChange}
                        checked={PaymentFormData.paymentOption === "OPTCRDC"}
                        onFocus={() => handleError(null, "paymentOption")}
                      />

                      <label className="ml-2 mr-2">Credit Card</label>
                      <br />
                      <RadioButton
                        inputId="ingredient1"
                        name="paymentOption"
                        value="OPTDBCRD"
                        onChange={PaymentformDataChange}
                        checked={PaymentFormData.paymentOption === "OPTDBCRD"}
                        onFocus={() => handleError(null, "paymentOption")}
                      />

                      <label className="ml-2 mr-2">Debit Card</label>
                      <br />
                      <RadioButton
                        inputId="ingredient1"
                        name="paymentOption"
                        value="OPTNBK"
                        onChange={PaymentformDataChange}
                        checked={PaymentFormData.paymentOption === "OPTNBK"}
                        onFocus={() => handleError(null, "paymentOption")}
                      />

                      <label className="ml-2">Net Banking</label>
                      <br />
                      <RadioButton
                        inputId="ingredient1"
                        name="paymentOption"
                        value="OPTUPI"
                        onChange={PaymentformDataChange}
                        checked={PaymentFormData.paymentOption === "OPTUPI"}
                        onFocus={() => handleError(null, "paymentOption")}
                      />

                      <label className="ml-2">UPI</label>

                      {error && UserformError.paymentOption && (
                        <div className="text-red">
                          {UserformError.paymentOption}
                        </div>
                      )}
                    </div>
                  </div>
                  <br />

                  <div
                    className="button-container"
                    style={{ justifyContent: "center" }}
                  >
                    <Button
                      label="Make Payment"
                      severity="danger"
                      icon="pi pi-check"
                      loading={loading}
                      onClick={handleSubmit}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubmitForm;
